import { render, staticRenderFns } from "./StudentComment.vue?vue&type=template&id=6f31236c&scoped=true&lang=pug&"
import script from "./StudentComment.vue?vue&type=script&lang=ts&"
export * from "./StudentComment.vue?vue&type=script&lang=ts&"
import style0 from "./StudentComment.vue?vue&type=style&index=0&id=6f31236c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f31236c",
  null
  
)

export default component.exports